<template>
  <div class="nkn-core-technology">
    <div class="common-sub-title">{{$t("developer.coreTech.title")}}</div>
    <div class="row">
      <div class="col-xs-6 col-sm-6 col-md-4 core-module-line">
        <core-module>
          <img v-lazy="'/static/img/developer/coreTech/DDNT.png'" slot="coreTech-pic" class="pic-core-POR">
          <span slot="coreTech-title">{{$t("developer.coreTech.subtitle1")}}</span>
          <p slot="coreTech-content">{{$t("developer.coreTech.subContent1")}}</p>
        </core-module>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-4 core-module-line">
        <core-module>
          <img v-lazy="'/static/img/developer/coreTech/Scalable.png'" slot="coreTech-pic" class="pic-core-Scalable">
          <span slot="coreTech-title">{{$t("developer.coreTech.subtitle3")}}</span>
          <p slot="coreTech-content">{{$t("developer.coreTech.subContent3")}}</p>
        </core-module>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-4 core-module-line">
        <core-module>
          <img v-lazy="'/static/img/developer/coreTech/POR.png'" slot="coreTech-pic" class="pic-core-Incentivized">
          <span slot="coreTech-title">{{$t("developer.coreTech.subtitle2")}}</span>
          <p slot="coreTech-content">{{$t("developer.coreTech.subContent2")}}</p>
        </core-module>
      </div>
    </div>
  </div>
</template>

<script>
import CoreModule from '@/components/developer/plugins/CoreModule'
export default {
  components: {
    CoreModule
  }
}
</script>

<style lang="scss" scoped>
.nkn-core-technology{
  @include common-inner();
  @media screen and (max-width: 768px) {
    .core-module-line {
      width: 345px;
      display: block;
      float: none;
      margin: 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/developer/nknCoreTech.vue